<template>
  <div class="row q-col-gutter-md">
      <div class="col-12 text-subtitle1 text-center" :class="$q.platform.is.mobile && !is_modal ? 'text-white' : ''">
          {{ $t('we_are_under_renovation_and_soon_we_will_bring_a_new_platform_full_of_news_for_you') }}
      </div>
  </div>
</template>

<script>
export default {
    name: 'UnderMaintenance',

    props: ['is_modal']
}
</script>

<style>

</style>